import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  superBatchGroupModulesSelector,
  setSelectedSuperBatchGroupModule,
} from 'features/satManagement';
import BatchDetailsTable from 'pages/BatchDetailsTable';
import ButtonToFetchBatchDetails from 'pages/ButtonToFetchBatcheDetails';
import SectionHeading from 'components/SectionHeading';
import SuperBatchGroupSelect from 'components/SuperBatchGroupSelect';

export default function ResetSatPage() {
  const dispatch = useDispatch();
  const selectedSuperBatch = useSelector(superBatchGroupModulesSelector);

  const handleSuperBatchChange = useCallback(
    (option) => {
      dispatch(setSelectedSuperBatchGroupModule(option));
    },
    [dispatch]
  );
  // value hai toh enable buttonToFetchBAtch
  return (
    <div>
      <SectionHeading
        title="Batch Allocation"
        subtitle="Select the batch"
        value={selectedSuperBatch}
      />
      <SuperBatchGroupSelect
        onChange={handleSuperBatchChange}
        selectedSuperBatch={selectedSuperBatch}
      />
      <ButtonToFetchBatchDetails selectedSuperBatch={selectedSuperBatch} />
      <BatchDetailsTable />
    </div>
  );
}
